// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_8d3e69c7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_881e8c9b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_189c4da7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_fd756ff3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_f6e128ac",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_e0e27fc0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_0ab7d564",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_b5abd0c9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_0c20dd62",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_99cea099",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_56f2d569",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_b6438609",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_23267be0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_08821e0d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_0ca3399b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_47124221",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_91d8d67f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_16667971",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_5689cf00",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_c9cf0f2d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_c31e58a6",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_b2ace9ca",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_75080735",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_59116855",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_f36b3fc3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_96739f15",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_675c1dee",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_4b217b9b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_35d83ee3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_1ac6f8fa",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_b5c10642",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_0b877539",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_449d759b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_c119b291",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_1adc77ba",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_09fe16d0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_4544b814",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_e55d5577",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_ba41fdfc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_8575a8bd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_53fe113f",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_bd6a0117",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_a2bdc533",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_53e813cb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_91d36963",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_8fc90767",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_29e534d1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_5e953263",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_39a4cd7b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_abf8fd5a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_d9858307",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_830872f6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_7ac0e8be",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_c6faa37c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_dd9a6e6d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_4b74d721",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_1293ef47",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_3c1718b1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_6cb64274",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_b5b61ac1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_08c3343a",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_675bb2dc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_d4a009ca",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_8e3e771e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_b5f4821b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_6a73b4a4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_5e1f3886",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_adcff734",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_65658d42",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_db130976",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_6360dadc",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_b6706ed9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_2ed4f8d7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_807b646c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_44e4f3c3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_3f90b42c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_36b35cfb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_c12e63fe",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_87b92480",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_a3df5436",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_421bc29d",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_9cae3766",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_6947c7cb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_d76205b5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_e1112c8d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_0624701b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_5cab6bf7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_a04b6b4c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_73c708b3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_56363c45",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_ba8f614f",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/2e4cd9ce" /* webpackChunkName: "config_i18n_46config_46ts_2e4cd9ce" */)
]
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr",
    name: "Français",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "es",
    name: "Español",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

